import React, { PropsWithChildren } from "react";

import { useIsFetching } from "@tanstack/react-query";

import { PageContentBackdropWithLoader } from "@/common/components/backdrop/content-backdrop/PageContentBackdropWithLoader";

interface Props extends PropsWithChildren {
  navigationWidth: number;
}

const PageContentLoadingIndicator: React.FC<Props> = ({ children, navigationWidth }) => {
  const globalFetchingCount = useIsFetching({
    predicate: (query) => query.meta?.loadingScope === "pageContent",
  });

  const isLoading = globalFetchingCount > 0;

  return (
    <>
      {children}
      <PageContentBackdropWithLoader open={isLoading} navigationWidth={navigationWidth} />
    </>
  );
};

export default PageContentLoadingIndicator;
